import React from 'react';

import type { Appearance } from '@atlaskit/button/old-button/types';
import Button, { type ButtonProps } from '@atlaskit/button/standard-button';

type Diff<T, U> = T extends U ? never : T;

type PageProps = Diff<
	ButtonProps,
	{
		appearance?: Appearance;
		autoFocus: boolean;
		isDisabled: boolean;
		isLoading: boolean;
		spacing: 'compact' | 'default' | 'none';
		shouldFitContainer: boolean;
		type: 'button' | 'submit';
	}
> & { page?: any };

export default function Page(props: PageProps): React.JSX.Element {
	// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
	return <Button {...props} appearance="subtle" />;
}
